// extracted by mini-css-extract-plugin
module.exports = {"header":"infoPOI_header__1hS3h","image-wrapper":"infoPOI_image-wrapper__3B3LI"};